import { render } from "./AppEditorCanvas.vue?vue&type=template&id=127d4b40&scoped=true&ts=true"
import script from "./AppEditorCanvas.vue?vue&type=script&lang=ts"
export * from "./AppEditorCanvas.vue?vue&type=script&lang=ts"

import "./AppEditorCanvas.vue?vue&type=style&index=0&id=127d4b40&scoped=true&lang=css"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-127d4b40"]])

export default __exports__